import { createRouter, createWebHistory } from 'vue-router'
import Login from '../views/login.vue'
import Home from '../views/home.vue'
import refersh_RC_Code from '../views/refersh_RC_Code.vue'
import order from '../views/order/index.vue'
import ShopInfo from '../views/shopInfo/index.vue'
import comboInfo from '../views/comboInfo/index.vue'
import comboItemInfo from '../views/comboItemInfo/index.vue'
import personList from '../views/personList/index.vue'
import teamList from '../views/teamList/index.vue'
import feedback from '@/views/feedback/index.vue'
import description from '@/views/description/index.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    children: [
      {
        path: '/rich/personList',
        name: 'personList',
        component: personList,
      },
      {
        path: '/rich/teamList',
        name: 'teamList',
        component: teamList,
      },
      {
        path: '/rich/order',
        name: 'order',
        component: order,
      },
      {
        path: '/rich/shopInfo',
        name: 'shopInfo',
        component: ShopInfo,
      },
      {
        path: '/rich/comboInfo',
        name: 'comboInfo',
        component: comboInfo,
      },
      {
        path: '/rich/comboItemInfo',
        name: 'comboItemInfo',
        component: comboItemInfo,
      },
      {
        path: '/rich/refersh_RC_Code',
        name: 'refersh_RC_Code',
        component: refersh_RC_Code
      },

      {
        path: '/feedback',
        name: 'feedback',
        component: feedback
      },
      {
        path: '/description',
        name: 'description',
        component: description
      },
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
// 挂载路由导航守卫
router.beforeEach((to, from, next) => {
  //     next()  放行    next('/login')  强制跳转
  return next()
  console.log($cookies);
  if (to.path === '/login' || to.path === '/refersh_RC_Code') return next()
  // 获取token
  let cookie = $cookies.get('token')
  if (!cookie) return next('/login')
  next()
})

export default router
